export const blockIconsActionTaskAlt = (
	<span className='material-symbols-outlined'>task_alt</span>
);
